export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10971.ea3ea177.jpg";